<template>
  <div id="$address-book$" class="pad-list bt fb-col-start-start">
    <!-- :style="computedSizeStyle" -->

    <!-- 设备搜索输入框 -->
    <div
      v-if="!showSelectDetail"
      v-show="`${role}` === `3`"
      class="fb fb-main-start fb-cross-center search"
    >
      <div
        class="search-box item-flex-1 font-30 fb fb-main-start fb-cross-center"
      >
        <i class="iconfont mr-10 c-171A1D-56 font-28">&#xe66d;</i>
        <input
          ref="input"
          type="text"
          v-model="searchKey"
          placeholder="搜索设备名称"
        />
        <span
          @click="handlerToClearSearchKey"
          class="iconfont c-171A1D-40 ml-10"
          v-if="searchKey"
          >&#xe6f5;</span
        >
      </div>
    </div>

    <div v-if="!showSelectDetail" class="item-flex-1 fb-col-start-start hidden">
      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="!searchKey && `${role}` === `3`"
        :nodeNav="nodeNav"
        ref="nodeNav"
        nodeType="tpId"
        @click="handlerToGoBackTargetNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-show="!searchKey && showNode && showNode.length"
        class="select-all fb-start-center font-34 mb-12"
        @click="handlerSelectAll"
      >
        <i
          class="iconfont mr-8 mt-2 font-48"
          :class="compuedIsSelectedAll ? 'c-006AFE' : 'c-171A1D-40'"
          >{{ compuedIsSelectedAll ? '&#xe66e;' : '&#xe66f;' }}</i
        >
        <span class="item-flex-1">全选</span>
      </div>
      <div
        v-show="!searchDevices.length && searchKey"
        class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
      >
        <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
        <span class="font-26">没有符合搜索条件的记录</span>
      </div>
      <div
        v-show="!showNode || !showNode.length"
        class="h-full c-171A1D-56 fb-col-center-center item-flex-1 relative"
      >
        <!-- <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe60b;</i> -->
        <common-no-data class="no-record bg-F6F6F6">
          <div class="no-classcard"></div>
          <p class="font-28 c-171A1D-40">暂无班牌</p>
        </common-no-data>
      </div>
      <!-- 搜索结果成员列表 -->
      <div class="item-flex-1 node-list font-34 pad-tree" v-show="searchKey">
        <div
          class="lh-30 pb-13 fb fb-cross-center fb-main-between"
          v-for="(node, index) in searchDevices"
          :key="node.classPadId"
        >
          <i
            @click="handlerSelect(node, true)"
            class="iconfont mr-8 mt-2 pt-13 font-48"
            :class="node.isSelected ? 'c-006AFE' : 'c-171A1D-40'"
            >{{ node.isSelected ? '&#xe66e;' : '&#xe66f;' }}</i
          >
          <div
            class="item-flex-1 fb fb-cross-center fb-main-between pt-13"
            :class="{ bt: index > 0 }"
          >
            <span class="item-flex-1" @click="handlerSelect(node, true)">
              {{ node.deviceName }}
            </span>
          </div>
        </div>
      </div>
      <!-- 子级部门列表 -->
      <div
        class="item-flex-1 node-list font-34 pad-tree"
        v-show="!searchKey && showNode && showNode.length"
      >
        <div
          class="lh-30 pb-13 fb fb-cross-center fb-main-between hidden-x"
          v-for="(node, index) in showNode"
          :key="node.deptDingId || node.classPadId"
        >
          <i
            @click="handlerSelect(node)"
            class="iconfont mr-8 mt-2 pt-13 font-48"
            :class="node.isSelected ? 'c-006AFE' : 'c-171A1D-40'"
            >{{ node.isSelected ? '&#xe66e;' : '&#xe66f;' }}</i
          >
          <div
            class="item-flex-1 fb fb-cross-center fb-main-between pt-13 hidden-x"
            :class="{ bt: index > 0 }"
          >
            <span class="w-adapt-24 text-ellipsis" @click="handlerSelect(node)">
              {{
                showType === 0
                  ? node.deviceName
                  : `${node.deptName} (${node.classPadCount})`
              }}
            </span>
            <span
              v-if="node.hasChildren || node.classNextHigherLevel"
              @click.stop="handlerShowNext(node)"
              class="next item-shrink-0"
            >
              <i class="iconfont">&#xe714;</i>下级
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看详情 -->
    <div v-else class="width-full height-full fb fb-col">
      <div class="item-flex-1 scroll pt-12 pb-60" refs="scroller">
        <div
          v-for="(device, index) in selectedDeviceList"
          :key="device.deviceSns"
          class="bg-FFFFFF pl-16"
        >
          <div
            class="bg-FFFFFF h-56 fb fb-main-between fb-cross-center"
            :class="{ bt: index > 0 }"
            @click.stop="clearDevice(device)"
          >
            <span class="font-34 pr-5">{{ device.deviceName }}</span>
            <i class="iconfont font-40 c-171A1D-40 mr-16">&#xe670;</i>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="showSelectDetail = false"
          >确定</common-button
        >
      </div>
    </div>
    <div
      v-show="showNode && showNode.length"
      class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8"
    >
      <div class="item-flex-1 c-006AFE" @click.stop="handlerViewDetail">
        已选择: {{ result.deviceSns.length }}台
        <i
          v-show="result.deviceSns.length"
          class="ml-8 c-006AFE iconfont font-38"
          >&#xe610;</i
        >
      </div>
      <common-button width="80" height="32" @click="handlerToSubmit"
        >确定</common-button
      >
    </div>
  </div>
</template>

<script>
import { commonNodeNav, commonButton } from '@/components/commonAddressBook'
import { NODE_TYPE, LEAVE_ROLE } from '@/utils/constUtils'
import { setLeft, removeLeft, pushNullUrl } from '@/utils/comUtils'
import API from '@/api'
import { commonNoData } from '@/components'
import { mcConfirm, mcToast, mcSetTitle } from '@/utils/mcSdkUtils'

const VIRTUAL_MODE_ID = {
  classMode: `-99`,
  dormMode: `-999`
}
export default {
  name: 'MSchoolPadList',
  components: {
    commonNodeNav,
    commonButton,
    commonNoData
  },
  props: {},
  data() {
    return {
      searchKey: '', // 成员搜索关键字
      nodeNav: [], // 部门导航条
      selectedDeptNodes: [], // 已勾选校区、学段、年级、年级节点列表(仅限多选)
      selectedPadNodes: [], // 已勾选学生和家长节点列表(仅限多选)
      selectedNode: null, // 已勾选节点(仅限单选)
      defaultSelected: {},
      currentCampus: {},
      wait: 300, // 防抖时间默认为0.3s
      timeout: null,
      padTree: [], // 树
      showNode: [], // 当前显示节点
      showType: 1, // 当前节点类型 0 叶子节点 1 部门节点
      searchDevices: [],
      allDevices: [],
      result: {
        deviceSns: [],
        dingDeptsIds: [],
        dingDepts: []
      },
      showSelectDetail: false,
      showConfirm: false,
      clearConfirm: null
    }
  },
  computed: {
    // 计算组件尺寸大小
    computedSizeStyle() {
      return {
        width: `${window.innerWidth}px`,
        height: `${window.innerHeight}px`
      }
    },
    //  判断当前节点列表是否已全选
    compuedIsSelectedAll() {
      let _isSelectAll = true
      switch (`${this.role}`) {
        case '2':
          _isSelectAll =
            (this.showNode && this.showNode.length) ===
            (this.result.deviceSns && this.result.deviceSns.length)
          break
        case '3':
          ;(this.showNode || []).forEach(item => {
            if (!item.isSelected) {
              _isSelectAll = false
            }
          })
          break
      }

      return _isSelectAll
    },
    //  选择结果文本
    computedResultText() {
      let _text = ''
      this.result.deviceSns &&
        this.result.deviceSns.length &&
        (_text = `已选择：${this.result.deviceSns.length}台`)
      return _text
    },
    selectedDeviceList() {
      return (
        this.result.deviceSns &&
        this.result.deviceSns.length &&
        this.result.deviceSns.reduce(
          (list, item) =>
            list.concat(
              this.allDevices.find(device => device.deviceSn === item)
            ),
          []
        )
      )
    }
  },
  watch: {
    searchKey(v) {
      if (v !== '') {
        this.searchDebounce(this.squirrelPublishSearchClassPad, this.wait)()
      } else {
        this.searchPeopleList = []
      }
    }
  },
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    this.title && mcSetTitle(this.title)
    this.currentCampus = Object.assign({}, this.campus)
    this.result.deviceSns = this.selectedDevices || []
    this.result.dingDeptsIds = this.selectedDeptIds || []
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    // 下级
    handlerShowNext(node) {
      this.showNode = node.classNextHigherLevel ? node.data : node.children
      this.showType = node.classNextHigherLevel ? 0 : 1
      this.methodUpdateNodeNav({
        tpId: node.deptDingId,
        name: node.deptName,
        deptType: node.deptType,
        showType: this.showType,
        children: this.showNode
      })
    },
    // 清空搜索
    handlerToClearSearchKey() {
      this.searchKey = ''
      this.$refs.input.blur()
    },
    // 搜索防抖 触发事件后函数不会立即执行，而是在 wait 秒后执行，如果在 wait 秒内又触发了事件，则会重新计算函数执行时间
    searchDebounce(func, wait) {
      let _that = this
      // eslint-disable-next-line space-before-function-paren
      return function () {
        let context = this
        let args = arguments
        if (_that.timeout) clearTimeout(_that.timeout)
        _that.timeout = setTimeout(() => {
          func.apply(context, args)
        }, wait)
      }
    },
    //  初始化
    init(nofresh) {
      switch (`${this.role}`) {
        case '2':
          this.squirrelPublishListAdviserClassPad()
            .then(list => {
              this.showType = 0
              this.result.deviceSns &&
                this.result.deviceSns.length &&
                list &&
                list.length &&
                list.forEach(item => {
                  if (this.result.deviceSns.indexOf(item.deviceSn) > -1) {
                    item.isSelected = true
                  }
                })
              this.showNode = list
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
          break
        case '3':
          this.nodeNav = []
          this.methodUpdateNodeNav({
            tpId: this.currentCampus.tpId,
            name: this.currentCampus.name,
            deptType: NODE_TYPE.campus
          })
          if (nofresh) {
            this.showType = 1
            this.showNode = this.padTree
          } else {
            if (this.multipleMode) {
              // 管理员需要判断是否存在宿舍模式与班牌模式
              this.getVirtualTree()
            } else {
              this.squirrelGetClassPadDeptTree()
                .then(list => {
                  this.walkTree(list, true)
                  this.padTree = list
                  this.showNode = list
                  this.showType = 1
                  this.allDevices = this.getDevices(list)
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
            }
          }
          break
      }
    },
    getDevices(list) {
      const devices = []
      ;(list || []).forEach(element => {
        let {
          hasChildren,
          children,
          data = [],
          deptDingId,
          parentIds = []
        } = element
        // 接口返回null兼容
        data = data || []
        children = children || []
        parentIds = parentIds || []

        const pids = parentIds.concat([deptDingId])
        element.parentIds = pids
        if (hasChildren) {
          children.forEach(child => (child.parentIds = pids))
          const childs = this.getDevices(children)
          devices.push(...childs)
        } else {
          data.forEach(child => (child.parentIds = pids))
          devices.push(...data)
        }
      })
      return devices
    },
    getVirtualTree() {
      // 思路：宿舍模式和班牌模式都存在的，再原有的树的基础上，再抽离一层虚拟的 [模式节点]
      // 最后向外暴露的数据再剔除 虚拟的 [模式节点]

      API.getDeviceMode({
        campusId: this.currentCampus.tpId,
        operUserRoleTypes: `${this.role}`
      })
        .then(res => {
          if (res.message) return Promise.reject(res.message)
          res = res || []
          // 1: 班牌模式 2: 通话模式 3: 宿舍模式
          return {
            dormMode: res.includes(3),
            classMode: !!res.find(item => item !== 3)
          }
        })
        .then(({ dormMode, classMode }) => {
          return Promise.all([
            dormMode ? this.deviceDormBuilding() : Promise.resolve([]),
            classMode ? this.squirrelGetClassPadDeptTree() : Promise.resolve([])
          ])
        })
        .then(([dormList, classlist]) => {
          let _dormLen = dormList.length
          let _classLen = classlist.length
          let _treeList = []

          if (_dormLen && _classLen) {
            // 兼有
            _treeList = [
              {
                deptDingId: `${VIRTUAL_MODE_ID.classMode}`,
                deptType: -1,
                deptName: '班牌模式',
                classPadCount: this.getNodeclassPadCount(classlist),
                hasChildren: true,
                classNextHigherLevel: false,
                children: classlist
              },
              {
                deptDingId: `${VIRTUAL_MODE_ID.dormMode}`,
                deptType: -1,
                deptName: '宿舍模式',
                classPadCount: this.getNodeclassPadCount(dormList),
                hasChildren: true,
                classNextHigherLevel: false,
                children: dormList
              }
            ]
          } else {
            // 只存其一
            if (_dormLen) {
              _treeList = dormList
            } else if (_classLen) {
              _treeList = classlist
            }
          }

          this.allDevices = []
          this.walkTree(_treeList, true)
          this.padTree = _treeList
          this.showNode = _treeList
          this.showType = 1
          this.allDevices = this.getDevices(_treeList)
        })
        .catch(err => {
          this.$Toast({
            content: err ? err.message || err : '网络开小差了'
          }).show()
        })
    },
    getNodeclassPadCount(nodeList) {
      let _count = 0

      if (!(nodeList && nodeList.length)) return _count

      return nodeList.reduce((total, item) => {
        return total + item.classPadCount || 0
      }, _count)
    },
    // 遍历树 添加是否勾选
    walkTree(tree, isInit) {
      for (let i = 0; i < (tree || []).length; i++) {
        if (tree[i].deviceSn) {
          // 叶子节点截止
          const _idx = this.result.deviceSns.indexOf(tree[i].deviceSn)
          tree[i].isSelected = _idx > -1
          this.allDevices.push(tree[i])
        } else {
          const _idx = this.result.dingDeptsIds.indexOf(tree[i].deptDingId)
          tree[i].isSelected = _idx > -1
          const _node = tree[i].children || tree[i].data
          this.walkTree(_node)
        }
      }
    },
    // 导航栏返回目标节点
    handlerToGoBackTargetNode(_node, _index) {
      if (_index === 0) {
        this.init(true)
      } else {
        this.nodeNav.splice(_index + 1, this.nodeNav.length - _index - 1)
        this.$nextTick(() => {
          this.showNode = _node.children
          this.showType = _node.showType
        })
      }
    },
    // 切换节点全选状态
    handlerSelectAll() {
      if (this.compuedIsSelectedAll) {
        ;(this.showNode || []).forEach(item => {
          if (item.isSelected) {
            this.handlerSelect(item)
          }
        })
      } else {
        ;(this.showNode || []).forEach(item => {
          if (!item.isSelected) {
            this.handlerSelect(item)
          }
        })
      }
    },
    // 搜索树节点 勾选 _nodeNav: 自动记录路径
    async searchTreeNode(tree, node, _nodeNav) {
      const _tree = tree || this.padTree
      for (let i = 0; i < _tree.length; i++) {
        const tr = _tree[i]
        if (!tree) {
          _nodeNav = [{ tpId: this.currentCampus.tpId }]
        }
        if (tr.deviceSn && tr.deviceSn !== node.deviceSn) {
          i === _tree.length - 1 && _nodeNav.splice(_nodeNav.length - 1, 1)
        } else if (tr.deviceSn === node.deviceSn) {
          // 叶子节点截止
          tr.isSelected = node.isSelected
          this.preWalkNode(tr, tr.isSelected, _nodeNav)
        } else {
          const _node = tr.children || tr.data
          if (_node) {
            _nodeNav.push({ tpId: tr.deptDingId })
            await this.searchTreeNode(_node, node, _nodeNav)
          }
        }
      }
    },
    // 勾选向上遍历树
    preWalkNode(node, selected, _nodeNav) {
      _nodeNav = _nodeNav || this.nodeNav
      if (selected) {
        this.walkTreeToNode([..._nodeNav], node, selected)
      } else {
        let _singleTreeLevel = this.padTree || []
        for (let i = 0; i < _nodeNav.length; i++) {
          _singleTreeLevel.forEach(tree => {
            if (tree.deptDingId === _nodeNav[i].tpId) {
              tree.isSelected = selected
              _singleTreeLevel = tree.children
            }
          })
        }
      }
    },
    // 选中时 从树顶部遍历到节点
    walkTreeToNode(_nodeNav, node, selected) {
      let _singleTreeLevel = this.padTree
      _nodeNav.some((nav, i) => {
        let _returnFlag = false
        _singleTreeLevel.some(tree => {
          if (tree.deptDingId === nav.tpId) {
            _singleTreeLevel = tree.children || tree.data
            if (_singleTreeLevel) {
              if (i === _nodeNav.length - 1) {
                let _flag = true
                _singleTreeLevel.some(level => {
                  if (!level.isSelected) {
                    _flag = false
                    _returnFlag = true
                    return false
                  }
                })
                if (_flag) {
                  tree.isSelected = selected
                  if (_nodeNav.length > 1) {
                    _nodeNav.splice(_nodeNav.length - 1, 1)
                    this.walkTreeToNode(_nodeNav, node, selected)
                  }
                  return false
                } else {
                  _returnFlag = true
                  return false
                }
              }
            }
          }
        })
        if (_returnFlag) {
          return false
        }
      })
    },
    // 勾选向下遍历
    walkNode(node, selected) {
      for (let i = 0; i < node.length; i++) {
        node[i].isSelected = selected
        if (selected) {
          // 勾选
          if (node[i].deviceSn) {
            // 叶子节点截止
            const _idx = this.result.deviceSns.indexOf(node[i].deviceSn)
            _idx < 0 && this.result.deviceSns.push(node[i].deviceSn)
          } else {
            const _idx = this.result.dingDeptsIds.indexOf(node[i].deptDingId)
            _idx < 0 && this.result.dingDeptsIds.push(node[i].deptDingId)
            const _node = node[i].children || node[i].data
            _node && this.walkNode(_node, selected)
          }
        } else {
          // 去掉勾选
          if (node[i].deviceSn) {
            // 叶子节点截止
            const _idx = this.result.deviceSns.indexOf(node[i].deviceSn)
            _idx > -1 && this.result.deviceSns.splice(_idx, 1)
          } else {
            const _idx = this.result.dingDeptsIds.indexOf(node[i].deptDingId)
            _idx > -1 && this.result.dingDeptsIds.splice(_idx, 1)
            const _node = node[i].children || node[i].data
            _node && this.walkNode(_node, selected)
          }
        }
      }
      // 向前遍历 修改勾选状态
      this.preWalkNode(node, selected)
    },
    //  切换节点勾选状态
    async handlerSelect(node, isSearch) {
      if (node.isSelected) {
        if (this.showType === 0 || isSearch) {
          // 班牌
          node.isSelected = false
          const _idx = this.result.deviceSns.indexOf(node.deviceSn)
          this.result.deviceSns.splice(_idx, 1)
          isSearch && this.searchTreeNode(null, node, null)
          !isSearch && this.preWalkNode(node, node.isSelected)
        } else {
          // 部门
          node.isSelected = !node.isSelected
          const _idx = this.result.dingDeptsIds.indexOf(node.deptDingId)
          _idx > -1 && this.result.dingDeptsIds.splice(_idx, 1)
          const _node = node.children || node.data
          _node && this.walkNode(_node, node.isSelected)
        }
      } else {
        if (this.showType === 0 || isSearch) {
          node.isSelected = true
          this.result.deviceSns.push(node.deviceSn)
          isSearch && this.searchTreeNode(null, node, null)
          !isSearch && this.preWalkNode(node, node.isSelected)
        } else {
          node.isSelected = !node.isSelected
          const _idx = this.result.dingDeptsIds.indexOf(node.deptDingId)
          _idx < 0 && this.result.dingDeptsIds.push(node.deptDingId)
          const _node = node.children || node.data
          _node && this.walkNode(_node, node.isSelected)
        }
      }
    },
    // 遍历树中选中的部门
    walkTreeNode(tree) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].deptDingId) {
          tree[i].isSelected &&
            this.result.dingDeptsIds.push(tree[i].deptDingId)
          const _node = tree[i].children || tree[i].data
          _node && _node.length && this.walkTreeNode(_node)
        }
      }
    },
    // 提交选择信息
    handlerToSubmit() {
      /* eslint-disable */
      let _result = this.result.deviceSns
      if (!_result.length) {
        return mcToast({ msg: '请选择' })
      }
      this.result.dingDeptsIds = []
      ;+this.role === LEAVE_ROLE.admin && this.walkTreeNode(this.padTree)
      setTimeout(() => {
        this.close(this.result)
      }, 1)
    },
    // 更新导航条
    methodUpdateNodeNav(node, index) {
      if (index !== undefined && index > -1) {
        this.nodeNav = this.nodeNav.slice(0, index + 1)
      } else {
        this.nodeNav.push(node)
      }
    },
    //  退回拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(btnIndex => {
            if (btnIndex === 1) {
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 转化宿舍楼的数据
    mapDormBuilding(nodeList) {
      let result = []
      if (nodeList && nodeList.length) {
        nodeList.forEach(node => {
          let { classPadDormModes } = node
          classPadDormModes = classPadDormModes || []
          result.push({
            ...node,
            deptDingId: node.dormBuildingId,
            // deptType: 2,
            deptName: node.dormBuildingName,
            classPadCount: node.classPadCount,
            hasChildren: false,
            classNextHigherLevel: true,
            data: classPadDormModes.map(item => {
              return {
                ...item,
                classPadId: item.deviceId
              }
            }),
            children: null
          })
        })
      }
      return result
    },
    deviceDormBuilding() {
      return new Promise((resolve, reject) => {
        API.deviceDormBuilding({
          campusId: this.currentCampus.tpId,
          operUserRoleTypes: this.role
        })
          .then(res => {
            if (res.message) return Promise.reject(res.message)
            resolve(this.mapDormBuilding(res.padsInBuildings))
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 搜索班牌
    squirrelGetClassPadDeptTree(param) {
      const _param = {
        campusId: this.currentCampus.tpId,
        operUserRoleTypes: `${this.role}`
      }
      return new Promise((resolve, reject) => {
        API.squirrelGetClassPadDeptTree(_param)
          .then(res => {
            let _res = []
            if (res && res.message) {
              _res = []
            } else {
              _res = (res || {}).rootNodes || []
            }
            resolve(_res)
          })
          .catch(err => {
            console.log((err && err.message) || '网络开小差了')
          })
      })
    },
    // 班主任获取班牌
    squirrelPublishListAdviserClassPad(param) {
      const _param = {
        campusId: this.currentCampus.tpId,
        operUserRoleTypes: `${this.role}`
      }
      return new Promise((resolve, reject) => {
        API.squirrelPublishListAdviserClassPad(_param)
          .then(res => {
            let _res = []
            if (res && res.message) {
              _res = []
            } else {
              _res = res || []
            }
            resolve(_res)
          })
          .catch(err => {
            console.log((err && err.message) || '网络开小差了')
          })
      })
    },
    // 搜索班牌
    squirrelPublishSearchClassPad(param) {
      const _param = {
        campusId: this.currentCampus.tpId,
        deviceName: this.searchKey,
        gradeDingId: '',
        operUserRoleTypes: `${this.role}`
      }
      return new Promise((resolve, reject) => {
        API.squirrelPublishSearchClassPad(_param)
          .then(res => {
            if (res && res.message) {
            } else {
              let _res = res || []
              _res.forEach(item => {
                const _idx = this.result.deviceSns.indexOf(item.deviceSn)
                item.isSelected = _idx > -1
              })
              this.searchDevices = _res
            }
            resolve(res)
          })
          .catch(err => {
            console.log((err && err.message) || '网络开小差了')
          })
      })
    },
    // 查看已选学生
    handlerViewDetail() {
      if (!this.result.deviceSns.length) {
        return
      }
      this.showSelectDetail = true
    },
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选班牌？`,
        onConfirm() {
          that.result = {
            deviceSns: [],
            dingDeptsIds: [],
            dingDepts: []
          }
          that.clearWholeTree()
          that.$nextTick(() => {
            that.showSelectDetail = false
          })
        }
      }).show()
    },
    clearWholeTree(list = this.padTree) {
      for (let i = 0; i < list.length; i++) {
        const { hasChildren, children, data = [] } = list[i]
        list[i].isSelected = false
        if (hasChildren) {
          this.clearWholeTree(children)
        } else {
          ;(data || []).forEach(item => (item.isSelected = false))
        }
      }
    },
    clearDevice(device) {
      let _index = this.result.deviceSns.findIndex(
        item => item === device.deviceSn
      )
      if (_index > -1) {
        this.result.deviceSns.splice(_index, 1)
      }
      this.clearTargetDevice(device.deviceSn, device.parentIds)
    },
    clearTargetDevice(deviceSn, parentIds, list = this.padTree) {
      for (let i = 0; i < list.length; i++) {
        const {
          hasChildren,
          children,
          data = [],
          deptDingId,
          deptName
        } = list[i]
        if (parentIds.some(item => item === deptDingId)) {
          list[i].isSelected = false
          hasChildren && this.clearTargetDevice(deviceSn, parentIds, children)
        }
        ;(data || []).forEach(
          item => item.deviceSn === deviceSn && (item.isSelected = false)
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pad-list {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  div {
    width: 100%;
  }
  .search {
    width: 100%;
    height: 52px;
    padding: 8px;
    background: #ffffff;
    .search-box {
      padding: 7px;
      border-radius: 99999px;
      background: rgba(#171a1d, 0.08);
      > input {
        width: 100%;
        height: 21px;
        background: none;
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
  .select-all {
    background: #fff;
    padding: 12px 16px;
    height: 48px !important;
    min-height: 48px;
    line-height: 48px;
  }
  .node-list {
    padding: 0 16px;
    background: #ffffff;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    > div {
      &:last-child {
        border-bottom: none;
      }
      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
      .next {
        color: #006afe;
        padding-left: 8px;
        border-left: 1px solid rgba(#171a1d, 0.12);
        &.disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }
    }
  }

  .no-record {
    text-align: center;
    .no-classcard {
      width: 180px;
      height: 180px;
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
  .footer {
    :deep(.c-button) {
      height: 46px;
      line-height: 46px;
      border-radius: 8px;
    }
  }
}
</style>
